<template>
  <div class="form-wrapper">

    <div class="form-alert-errors" v-if="serverErrors && serverErrors.length > 0">
      <ul class="list-unstyled m-0">
        <li v-for="(error, i) in serverErrors" :key="i">{{ error }}</li>
      </ul>
    </div>

    <form @submit.prevent="login">
      <div class="intro-section__form">
        <div class="form-group">
          <input
              type="email"
              v-model="email"
              required
              class="input form-control"
              :placeholder="$t('forms.login_form.email')"
          />
        </div>

        <div class="form-group">
          <input-password
              v-model="password"
              :required="true"
              :placeholder="$t('forms.login_form.password')"
          />
        </div>

        <div class="form-group m-0">
          <button type="submit" class="btn btn-primary m-0 w-100">{{ $t('forms.login_form.login_btn') }}</button>
        </div>
      </div>

      <div class="form-group text-center mb-5">
        <router-link :to="{ name: 'reset-password' }">{{ $t('forms.login_form.forgot_password_btn') }}</router-link>
      </div>
      <SocialLogin v-if="($store.state.appConfig.appConfigReady && !$store.state.appConfig.disableSocialLogin)"/>
          <div class="row d-lg-flex align-items-center mt-4" v-if="thirdLevelDomain==='hublot'">
      <div class="col-lg-12">
        <PoweredBy
            :url="'https://business.getpica.com/?utm_source=hublot.getpica.com&utm_medium=website&utm_campaign=hublot'"/>
      </div>
    </div>
    </form>

  </div>
</template>


<script>
import InputPassword from "@/components/InputPassword";
import SocialLogin from "@/components/SocialLogin";
import PoweredBy from "@/components/PoweredBy.vue";
import {mapGetters} from "vuex";

export default {
  components: {PoweredBy, InputPassword, SocialLogin},
  data() {
    return {
      email: "",
      password: "",
      serverErrors: []
    }
  },

  computed: {
    ...mapGetters(['thirdLevelDomain']),
  },

  methods: {
    login() {
      this.serverErrors = []
      const data = {
        email: this.email,
        password: this.password
      }
      this.$store
          .dispatch("auth/login", data)
          .then(() => {
            // this.$bvModal.show('modal-marketing-consent')

            this.$router.push({name: 'checkins-list'})
          })
          .catch(err => {
            console.log('auth/login error', err.response.data)
            this.serverErrors = err.response.data.non_field_errors
          })
    }
  }
};
</script>
